// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"3a04b922","194":"e1887be7"}[chunkId] + ".chunk.css";
};